import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { LoadingService } from "./loading_service";
import { Injectable } from "@angular/core";
import { finalize } from "rxjs";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    this.loadingService.start();

    return next.handle(req).pipe(
      finalize(() => this.loadingService.stop())
    );
  }
}
